module.exports = __webpack_public_path__ + "img/icon_sb_rating_alt_desktop_v1.3f044b0.svg";